import { Star } from "lucide-react";

const PRESS = [
    "FORBES MIDDLE EAST",
    "BLOOMBERG",
    "ARABIAN BUSINESS",
    "FINANCIAL TIMES",
    "REUTERS",
    "GULF NEWS",
    "THE NATIONAL",
    "WSJ",
    "THE ECONOMIST",
];

export default function TrustBar() {
    return (
        <section data-testid="trust-bar" className="relative bg-white border-y border-cream-deep py-6 overflow-hidden">
            <div className="max-w-[1280px] mx-auto px-6 md:px-10 flex flex-col md:flex-row gap-4 md:gap-10 items-center justify-between">
                <div className="flex items-center gap-3 shrink-0">
                    <div className="flex gap-0.5">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <Star key={i} size={12} className="text-gold fill-gold" />
                        ))}
                    </div>
                    <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-muted">
                        <span className="text-ink">4.9 / 5</span> · 8,200+ reviews
                    </div>
                </div>

                <div className="flex-1 overflow-hidden relative max-w-2xl">
                    <div className="absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-white to-transparent z-10" />
                    <div className="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-white to-transparent z-10" />
                    <div className="flex gap-10 marquee-track" style={{ width: "max-content" }}>
                        {[...PRESS, ...PRESS].map((p, i) => (
                            <span
                                key={i}
                                className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-muted whitespace-nowrap"
                            >
                                {p}
                            </span>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
}
